import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { Drawer } from '@/components/ui/Drawer';
import {
	OrganizationFormItem,
	CompanyFormItem,
	SectorFormItem,
	LineFormItem,
	WorkstationFormItem,
	UploadDateFormItem
} from '@/components/views/Resolution886/components/Form';

interface FilterDrawerProps {
	open?: boolean;
	fieldName: string;
	onClear: () => void;
	onClose: () => void;
	onSubmit: () => void;
}

export function FilterDrawer({ open = false, fieldName, onClose, onClear, onSubmit }: Readonly<FilterDrawerProps>) {
	return (
		<Drawer
			open={open}
			onClose={onClose}
			gutter={[16, 16]}
			onClear={onClear}
			onSubmit={onSubmit}
			title={I18n.get('Filters')}
		>
			<Row>
				<Col span={24}>
					<OrganizationFormItem
						disabled
						required={false}
						labelCol={{ span: 24 }}
						fieldName={[fieldName, 'organization_id']}
					/>
				</Col>
				<Col span={24}>
					<CompanyFormItem
						disabled
						required={false}
						labelCol={{ span: 24 }}
						fieldName={[fieldName, 'company_id']}
					/>
				</Col>
				<Col span={24}>
					<SectorFormItem fieldName={[fieldName, 'sector_id']} required={false} labelCol={{ span: 24 }} />
				</Col>
				<Col span={24}>
					<LineFormItem fieldName={[fieldName, 'line_id']} required={false} labelCol={{ span: 24 }} />
				</Col>
				<Col span={24}>
					<WorkstationFormItem
						required={false}
						labelCol={{ span: 24 }}
						fieldName={[fieldName, 'workstation_id']}
					/>
				</Col>
				<Col span={24}>
					<UploadDateFormItem
						fieldName={[fieldName, 'upload_date']}
						required={false}
						labelCol={{ span: 24 }}
					/>
				</Col>
			</Row>
		</Drawer>
	);
}
